import { makeActions } from '@redux/crudCreator/actions';
import { convertResponseData } from '@redux/crudCreator/dataProvider';
import { apiWrapper } from '@redux/crudCreator/reduxUtils';
import { CreatePayloadType } from '@redux/crudCreator/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  cancelOrderApi,
  commentReturnApi,
  confirmForcePaymentApi,
  confirmForceToCODApi,
  confirmOrderApi,
  confirmRefundApi,
  editDeliveryInformationApi,
  editInvoiceInformationApi,
  exportWSApi,
  failQCApi,
  markAsRefundApi,
  markDeliverySuccessApi,
  moveToLostApi,
  moveToPendingApi,
  moveToReadyToPickApi,
  passQCApi,
  refreshOrderApi,
  replaceSkuApi,
  revertToPreviousStateApi,
} from 'api/orders';

export const MODEL_NAME = 'orders';
export const ordersActions = makeActions(MODEL_NAME);

export const getAllOrders = ordersActions.getAll;
export const editOrders = ordersActions.edit;
export const createOrders = ordersActions.create;
export const getByIdOrders = ordersActions.getDataById;

export const replaceSku = createAsyncThunk(
  'orders/replaceSku',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        replaceSkuApi,
        data,
      );
      if (response) {
        return {
          ...response,
          ...payload,
        };
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const comment = createAsyncThunk(
  'auth/comment',
  async (payload: CreatePayloadType, thunkAPI) => {
    try {
      const response = await apiWrapper(null, commentReturnApi, payload);
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const confirmOrder = createAsyncThunk(
  'orders/confirmOrder',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(options, confirmOrderApi, data);
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const cancelOrder = createAsyncThunk(
  'orders/cancelOrder',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(null, cancelOrderApi, data);
      if (response) {
        return {
          ...response,
          ...payload,
        };
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const refreshOrder = createAsyncThunk(
  'orders/refreshOrder',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(null, refreshOrderApi, data);
      if (response) {
        return {
          ...response,
          ...payload,
        };
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const confirmForcePayment = createAsyncThunk(
  'orders/confirmOrder',
  async (payload: any, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(options, confirmForcePaymentApi, data);
      if (response) {
        thunkAPI.dispatch(
          getByIdOrders({
            data: data,
            options: {
              isRequestApi: true,
              extraParams: {
                join: [
                  'orderBatch',
                  'chainStore',
                  'location',
                  'shop',
                  'orderItems',
                  'histories',
                  'transferOrders',
                  'orderReturn',
                  'orderShipping',
                  'histories.creator',
                  'newOrderExchange',
                ],
              },
            },
          }),
        );
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const confirmForceToCOD = createAsyncThunk(
  'orders/confirmForceToCOD',
  async (payload: any, thunkAPI) => {
    // const { data } = payload;
    try {
      const response = await apiWrapper(null, confirmForceToCODApi, payload);
      if (response) {
        thunkAPI.dispatch(
          getByIdOrders({
            data: payload,
            options: {
              isRequestApi: true,
              extraParams: {
                join: [
                  'orderBatch',
                  'chainStore',
                  'location',
                  'partner',
                  'shop',
                  'orderItems',
                ],
              },
            },
          }),
        );
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const exportWS = createAsyncThunk(
  'orders/exportWS',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(null, exportWSApi, data);
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const markDeliverySuccess = createAsyncThunk(
  'orders/markDeliverySuccess',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(null, markDeliverySuccessApi, data);
      if (response) {
        return { data: response, success: true };
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const moveToLost = createAsyncThunk(
  'orders/moveToLost',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        moveToLostApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ success: true, response });
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const moveToPending = createAsyncThunk(
  'orders/moveToPending',
  async (payload: any, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        moveToPendingApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ success: true, response });
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const revertToPreviousState = createAsyncThunk(
  'orders/revertToPreviousState',
  async (payload: any, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        revertToPreviousStateApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const failQC = createAsyncThunk(
  'orders/failQC',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        failQCApi,
        data,
      );
      if (response) {
        return { data: response, success: true };
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const passQCOrders = createAsyncThunk(
  'orders/passQCOrders',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        passQCApi,
        data,
      );
      if (response) {
        return { data: response, success: true };
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const moveToReadyToPick = createAsyncThunk(
  'orders/moveToReadyToPick',
  async (payload: any, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        moveToReadyToPickApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const editInvoiceInformation = createAsyncThunk(
  'orders/editInvoiceInformation',
  async (payload: any, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        editInvoiceInformationApi,
        data,
      );
      const result = convertResponseData('EDIT', response, {
        primaryKey: 'id',
      });
      if (result) {
        return { data: { ...data, ...result }, options };
      }
      return thunkAPI.rejectWithValue({
        error: true,
        data: { ...data, ...response },
      });
      // return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const editDeliveryInformation = createAsyncThunk(
  'orders/editDeliveryInformation',
  async (payload: any, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        editDeliveryInformationApi,
        data,
      );
      const result = convertResponseData('EDIT', response, {
        primaryKey: 'id',
      });
      if (result) {
        return { data: { ...data, ...result }, options };
      }
      return thunkAPI.rejectWithValue({
        error: true,
        data: { ...data, ...response },
      });
      // return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const confirmRefund = createAsyncThunk(
  'orders/confirmRefund',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        {
          isShowSuccessNoti: false,
          ...options,
        },
        confirmRefundApi,
        data,
      );
      if (response) {
        return { data: response, success: true };
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);

export const confirmRefundExchange = createAsyncThunk(
  'orders/confirmRefundExchange',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        {
          isShowSuccessNoti: false,
          ...options,
        },
        confirmRefundApi,
        data,
      );
      if (response) {
        return { data: response, success: true };
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);

export const markAsRefundExchange = createAsyncThunk(
  'orders/markAsRefundExchange',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        {
          isShowSuccessNoti: true,
          ...options,
        },
        markAsRefundApi,
        data,
      );
      if (response) {
        thunkAPI.dispatch(
          getByIdOrders({
            data: data,
            options: {
              isRequestApi: true,
              extraParams: {
                join: [
                  'orderBatch',
                  'chainStore',
                  'location',
                  'shop',
                  'orderItems',
                  'histories',
                  'transferOrders',
                  'orderReturn',
                  'orderShipping',
                  'histories.creator',
                  'newOrderExchange',
                ],
              },
            },
          }),
        );
        return { data: response, success: true };
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);
